import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DatePicker from 'react-datepicker';
import moment from 'moment-timezone';
moment.tz.setDefault('Asia/Seoul');
import 'react-datepicker/dist/react-datepicker.css';

import * as cmAPI_Action from 'actions/commons';
import cm from 'helpers/commons';
import toastr from 'helpers/toastr';

import { Dropdown, Form, Input, Label, Icon, Button } from 'semantic-ui-react';

class DateForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: moment().startOf('month'),
      endDate: moment(),
      month: moment().format('MM'),
      activeCustomPreset: null,
      sDateShow: false,
      eDateShow: false
    };

    this.startDateRef = React.createRef(null);
    this.endDateRef = React.createRef(null);
  }

  componentWillMount() {
    const { startDate, endDate } = this.state;
    const { defaultDay } = this.props;

    if (defaultDay) {
      const { startDay = 1, endDay } = defaultDay;
      const currentMonth = moment().startOf('month');
      let initStartDate;
      const initEndDate = endDay ? moment().date(endDay) : moment();

      // startDay가 endDay보다 큰 경우 (예: 26일~25일)
      if (startDay > (endDay || 31)) {
        // startDate는 이전 달의 startDay로 설정
        initStartDate = currentMonth
          .clone()
          .subtract(1, 'month')
          .date(startDay);
      } else {
        // 일반적인 경우 현재 달의 startDay로 설정
        initStartDate = currentMonth.date(startDay);
      }

      this.handleChange(initStartDate, 'sDate', false);
      this.handleChange(initEndDate, 'eDate', false);
    } else {
      // 기본값: 월 초부터 현재일
      this.handleChange(startDate, 'sDate', false);
      this.handleChange(endDate, 'eDate', false);
    }
  }

  getCustomPresetRange = (presetId, baseMonth = moment()) => {
    let startDate = null;
    let endDate = null;

    if (presetId === 'day-21') {
      startDate = baseMonth
        .clone()
        .subtract(1, 'month')
        .date(21);
      endDate = baseMonth.clone().date(20);
    } else if (presetId === 'day-26') {
      startDate = baseMonth
        .clone()
        .subtract(1, 'month')
        .date(26);
      endDate = baseMonth.clone().date(25);
    } else if (presetId === 'day-1') {
      const previousMonth = baseMonth.clone();
      startDate = previousMonth.clone().startOf('month');
      endDate = previousMonth.clone().endOf('month');
    }

    return { startDate, endDate };
  };

  getSelectedMonthBase = () => {
    const { month } = this.state;
    const currentMonth = moment().format('MM');
    const previousMonth = moment()
      .clone()
      .subtract(1, 'month')
      .format('MM');
    const twoMonthsAgo = moment()
      .clone()
      .subtract(2, 'month')
      .format('MM');

    if (month === previousMonth) {
      return moment().subtract(1, 'month');
    }

    if (month === twoMonthsAgo) {
      return moment().subtract(2, 'month');
    }

    if (month === currentMonth) {
      return moment();
    }

    return moment();
  };

  handleMonth = async (e, { value, id }) => {
    e.preventDefault();
    const { activeCustomPreset } = this.state;

    this.setState({
      month: value,
      activeCustomPreset: id === 'today' ? null : activeCustomPreset
    });

    const { defaultDay } = this.props;
    let newStartDate, newEndDate;

    if (id === 'today') {
      // 오늘 버튼 클릭시에는 defaultDay 무시하고 오늘 날짜로 설정
      newStartDate = moment();
      newEndDate = moment();
    } else {
      const targetMonth = value !== moment().format('MM') ? moment().subtract(id, 'month') : moment();

      if (activeCustomPreset) {
        const presetRange = this.getCustomPresetRange(activeCustomPreset, targetMonth);
        newStartDate = presetRange.startDate;
        newEndDate = presetRange.endDate;
      } else if (defaultDay) {
        const { startDay = 1, endDay } = defaultDay;

        // endDay가 없으면 해당 월의 마지막 날짜 사용
        const monthEndDay =
          endDay ||
          targetMonth
            .clone()
            .endOf('month')
            .date();

        // startDay가 endDay보다 큰 경우 (예: 26일~25일)
        if (startDay > monthEndDay) {
          // startDate는 이전 달의 startDay로 설정
          newStartDate = targetMonth
            .clone()
            .subtract(1, 'month')
            .date(startDay);
          newEndDate = targetMonth.clone().date(monthEndDay);
        } else {
          // 일반적인 경우 현재 달의 startDay, endDay로 설정
          newStartDate = targetMonth.clone().date(startDay);
          newEndDate = targetMonth.clone().date(monthEndDay);
        }
      } else {
        // defaultDay가 없는 경우 기존 로직 유지
        if (value !== moment().format('MM')) {
          newStartDate = targetMonth.clone().startOf('month');
          newEndDate = targetMonth.clone().endOf('month');
        } else {
          newStartDate = targetMonth.clone().startOf('month');
          newEndDate = moment();
        }
      }
    }

    await this.setState({
      startDate: newStartDate,
      endDate: newEndDate
    });

    this.handleChange(newStartDate, 'sDate', false);
    this.handleChange(newEndDate, 'eDate', false);
  };

  handleCustomPreset = async (e, { id }) => {
    e.preventDefault();

    const baseMonth = this.getSelectedMonthBase();
    const presetRange = this.getCustomPresetRange(id, baseMonth);

    if (!presetRange.startDate || !presetRange.endDate) {
      return;
    }

    await this.setState({
      startDate: presetRange.startDate,
      endDate: presetRange.endDate,
      activeCustomPreset: id
    });

    this.handleChange(presetRange.startDate, 'sDate', false);
    this.handleChange(presetRange.endDate, 'eDate', false);
  };

  handleChange = async (date, type, isActive) => {
    if (type === 'sDate') {
      await this.setState({
        startDate: date,
        sDateShow: false,
        activeCustomPreset: isActive ? null : this.state.activeCustomPreset
      });
    } else if (type === 'eDate') {
      await this.setState({
        endDate: date,
        eDateShow: false,
        activeCustomPreset: isActive ? null : this.state.activeCustomPreset
      });
    }

    // 날짜 초기화 시 date 가 null 로 전달된다 — 상태 반영까지만 하고 상위 전달은 건너뛴다
    if (!date) return;

    const { startDate, endDate, sDateShow, eDateShow } = this.state;
    const { maxDays = 92 } = this.props;
    const result = cm.dateCheck(startDate, endDate, true, maxDays); //날짜 체크
    const { commonFn } = this.props;

    await commonFn.changeDate({
      type: 'date',
      name: type,
      value: date.format('LL')
    });

    await commonFn.changeDate({
      type: 'dateCheck',
      name: 'isValue',
      value: result
    });

    if (!result.isState) {
      if (!sDateShow && !eDateShow) {
        toastr('top-right', 'warning', result.message);
      }

      // if(type === "sDate"){
      //   let tempDate = new Date(date);
      //   // this.handleChange(moment(tempDate).add(92, "days"), "eDate", false);
      // }else if(type === "eDate") {
      //   let tempDate = new Date(date);
      //   // this.handleChange(moment(tempDate).subtract(92, "days"), "sDate", false);
      // }
      return;
    }
  };

  calendarOpen = (type) => {
    // this.startDateRef.current.setOpen(true);
    // this.endDateRef.current.setOpen(true);
    //
    this.setState({
      sDateShow: true,
      eDateShow: true,
      month: null,
      activeCustomPreset: null
    });
    if (type === 'start') {
      // $('#end').click();
    } else {
      // $('#start').click();
    }
  };

  clickOutSide = (e) => {
    const { startDate, endDate } = this.state;
    const result = cm.dateCheck(startDate, endDate, true); //날짜 체크
    let path = e.target.className.split('__');
    if (path[0] !== 'react-datepicker') {
      if (!result.isState) {
        toastr('top-right', 'warning', result.message);
      }

      this.startDateRef.current.setOpen(false);
      this.endDateRef.current.setOpen(false);
      this.setState({
        sDateShow: false,
        eDateShow: false
      });
      // $('#end').click();
    }
  };

  isShow = (e, type) => {
    if (type === 'end') {
      this.setState({ eDateShow: false });
    } else {
      this.setState({ sDateShow: false });
    }
  };

  render() {
    const { openTodayBtn, style, allowFutureDates = false, customPresets = [] } = this.props,
      { month, activeCustomPreset, sDateShow, eDateShow, startDate, endDate } = this.state,
      monthMinus = {
        t: moment().format('LL'),
        n0: moment().format('MM'),
        n1: moment()
          .subtract(1, 'month')
          .format('MM'),
        n2: moment()
          .subtract(2, 'month')
          .format('MM')
      };
    return (
      <Form.Field inline className="date-form" style={style}>
        {customPresets.length > 0 ? (
          <Button.Group basic className="month-btn custom-range-btn">
            {customPresets.map((preset) => (
              <Button
                key={preset.id}
                id={preset.id}
                className={activeCustomPreset === preset.id ? 'active' : ''}
                onClick={this.handleCustomPreset}
              >
                {preset.label}
              </Button>
            ))}
          </Button.Group>
        ) : null}

        <Button.Group basic className="month-btn three-month">
          <Button
            value={monthMinus.n0}
            id={0}
            className={month === monthMinus.n0 ? 'active' : ''}
            onClick={this.handleMonth}
          >
            {monthMinus.n0}월
          </Button>
          <Button
            value={monthMinus.n1}
            id={1}
            className={month === monthMinus.n1 ? 'active' : ''}
            onClick={this.handleMonth}
          >
            {monthMinus.n1}월
          </Button>
          <Button
            value={monthMinus.n2}
            id={2}
            className={month === monthMinus.n2 ? 'active' : ''}
            onClick={this.handleMonth}
          >
            {monthMinus.n2}월
          </Button>
          <Button
            value={monthMinus.t}
            id={openTodayBtn ? 'today' : 'disabled'}
            className={month === monthMinus.t ? 'active' : ''}
            onClick={this.handleMonth}
          >
            오늘
          </Button>
        </Button.Group>

        <Input labelPosition="right" type="text" placeholder="Amount" className="form-element">
          <Label basic>
            <Icon disabled name="calendar" />
          </Label>
          <DatePicker
            id="start"
            className="startDate"
            selected={this.state.startDate}
            selectsStart
            startDate={this.state.startDate}
            endDate={this.state.endDate}
            onChange={(e) => this.handleChange(e, 'sDate', true)}
            onSelect={(e) => this.isShow(e, 'start')}
            dateFormat="YYYY-MM-DD"
            maxDate={allowFutureDates ? null : moment()}
            onFocus={() => this.calendarOpen('start')}
            onClickOutside={(e) => this.clickOutSide(e)}
            ref={this.startDateRef}
            // inline={sDateShow}
          />
        </Input>
        <Icon name="minus" className="datepicker-bar" />
        <Input labelPosition="right" type="text" placeholder="Amount" className="form-element">
          <Label basic>
            <Icon disabled name="calendar" />
          </Label>
          <DatePicker
            id="end"
            className="endDate"
            selected={this.state.endDate}
            selectsEnd
            startDate={this.state.startDate}
            endDate={this.state.endDate}
            onChange={(e) => this.handleChange(e, 'eDate', true)}
            onSelect={(e) => this.isShow(e, 'end')}
            dateFormat="YYYY-MM-DD"
            maxDate={allowFutureDates ? null : moment()}
            onFocus={() => this.calendarOpen('end')}
            onClickOutside={(e) => this.clickOutSide(e)}
            ref={this.endDateRef}
            // inline={eDateShow}
          />
        </Input>
      </Form.Field>
    );
  }
}

DateForm.propTypes = {
  allowFutureDates: PropTypes.bool,
  customPresets: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ),
  defaultDay: PropTypes.shape({
    endDay: PropTypes.number,
    startDay: PropTypes.number
  }),
  maxDays: PropTypes.number,
  openTodayBtn: PropTypes.bool,
  style: PropTypes.object
};

DateForm = connect(
  (state) => ({
    date: state.commons.date
  }),
  (dispatch) => ({
    commonFn: bindActionCreators(
      {
        changeDate: cmAPI_Action.ReduxDataSet
      },
      dispatch
    )
  })
)(DateForm);

export default DateForm;
